import type { ApiNetwork, Network } from '../types/shared';

const getApiPrefix = (network: Network): ApiNetwork => {
  switch (network) {
    case 'facebook':
      return '';
    case 'google':
      return 'ga';
    case 'snapchat':
      return 'sc';
    case 'tiktok':
      return 'tt';
    case 'x':
      return 'x';

    default:
      return '';
  }
};

export default getApiPrefix;
